<template>
  <div class="devpage5-page">
    <van-pull-refresh v-model="isLoading" @refresh="onReflash" class="devpage5-index">
      <div v-if="devdata">
        <van-nav-bar left-arrow class="crystal-nav" @click-right="devconfigshow = true" @click-left="gotohome">
          <template #left>
            <van-icon name="arrow-left" size="20px" color="#475569" />
          </template>
          <template #right>
            <van-icon name="setting-o" size="20px" color="#94a3b8" />
          </template>
          <template #title>
            <div class="nav-title-wrap">
              <span class="nav-devname">{{ devdata.udname }}</span>
              <span class="nav-did">ID: {{ did }}</span>
            </div>
          </template>
        </van-nav-bar>

	        <div class="temp-hero" :class="heroClass">
          <div class="temp-hero-inner">
            <div class="temp-value">{{ devdata.value.temperature }}<span class="temp-unit">℃</span></div>
            <div class="temp-time">更新时间 {{ devdata.time }}</div>
          </div>
        </div>

        <div class="content-area">
          <div class="info-card">
            <div class="info-item info-item--link" @click="gotoconfig()">
              <div class="info-item-left">
                <span class="iconfont icon-sinaweibo18 info-icon" style="color:#2dd4bf"></span>
                <span class="info-label">参数设置</span>
              </div>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 4L10 8L6 12" stroke="#94a3b8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>

          <div class="history-section">
            <div class="history-tabs">
              <button
                v-for="(tab, i) in historyTabs" :key="i"
                class="history-tab"
                :class="getHistoryClass(i)"
                @click="gethistory(tab.tnum, tab.tunit)"
              >{{ tab.label }}</button>
            </div>
            <div class="chart-card">
              <div id="tempChart" class="history-chart"></div>
            </div>
          </div>
        </div>
      </div>

      <van-action-sheet v-model="devconfigshow" :actions="actions" cancel-text="取消" @select="onSelect"
        :title="devdata && devdata.udname" class="crystal-actionsheet" />
      <DevGroup v-if="devgroupcard" :did="devdata && devdata.did" @configstatus="configstatus($event)"></DevGroup>
      <DevName v-if="devnamecard" :did="devdata && devdata.did" @configstatus="configstatus($event)"></DevName>
      <DevUnbind v-if="devunbindcard" :did="devdata && devdata.did" @configstatus="configstatus($event)"></DevUnbind>

	      <van-dialog
	        v-model="dialogFormVisible"
	        title="参数设置"
	        show-cancel-button
	        :beforeClose="handleClose"
	        class-name="crystal-dialog"
	      >
	        <div class="dialog-body">
	          <div class="dialog-item">
	            <label class="dialog-label">温度报警上限(℃)</label>
	            <div class="dialog-stepper">
	              <van-stepper v-model="configdata.tul" min="1" max="99" input-width="50px" button-size="30px" />
	            </div>
	          </div>
	          <div class="dialog-divider"></div>
	          <div class="dialog-item">
	            <label class="dialog-label">温度报警下限(℃)</label>
	            <div class="dialog-stepper">
	              <van-stepper v-model="configdata.tdl" min="1" max="99" input-width="50px" button-size="30px" />
	            </div>
	          </div>
	          <div class="dialog-divider"></div>
	          <div class="dialog-item">
	            <label class="dialog-label">温度校准(℃)</label>
	            <div class="dialog-stepper">
	              <van-stepper step="0.1" v-model="configdata.tjz" min="-10" max="10" input-width="50px" button-size="30px" />
	            </div>
	          </div>
	        </div>
	      </van-dialog>
    </van-pull-refresh>
  </div>
</template>

<script>
import DevGroup from "../general/apidevgroup.vue";
import DevName from "../general/apidevname.vue";
import DevUnbind from "../general/apidevunbind.vue";

export default {
  name: "DevPageKD5",
  components: {
    DevGroup,
    DevName,
    DevUnbind,
  },
  data() {
    return {
      historyTabs: [
        { label: "1小时", tnum: 1, tunit: "hour" },
        { label: "6小时", tnum: 6, tunit: "hour" },
        { label: "1天", tnum: 1, tunit: "day" },
        { label: "1周", tnum: 7, tunit: "day" },
      ],
      finished: true,
      dialogFormVisible: false,
      devconfigshow: false,
      devgroupcard: false,
      devnamecard: false,
      devunbindcard: false,
      isLoading: false,
      devdata: null,
      did: this.$route.query.did,
      actions: [
        { name: "更改分组", color: "#2dd4bf" },
        { name: "重命名", color: "#2dd4bf" },
        { name: "设置报警", color: "#2dd4bf" },
        { name: "解绑", color: "#fb7185" },
      ],
      configdata: {
        tul: "",
        tdl: "",
        tjz: 0,
      },
      history1: "",
      history2: "",
      history3: "",
      history4: "",
      templist: [],
      temptimelist: [],
    };
  },
  mounted() {
    this.GetDevData(this.did);
  },
  computed: {
    heroClass() {
      if (!this.devdata || !this.devdata.err) return "temp-hero--normal";
      const err = this.devdata.err;
      if (Array.isArray(err) && err.length > 0 && err[0] !== 0) {
        return "temp-hero--alert";
      }
      return "temp-hero--normal";
    },
  },
  methods: {
    getHistoryClass(i) {
      const map = [this.history1, this.history2, this.history3, this.history4];
      return map[i] && map[i].history1 ? "history-tab--active" : "";
    },
    gethistory(tnum, tunit) {
      this.overlay = true;
      this.history1 = "";
      this.history2 = "";
      this.history3 = "";
      this.history4 = "";
      if (tnum === 1 && tunit === "hour") { this.history1 = { history1: true }; }
      else if (tnum === 6 && tunit === "hour") { this.history2 = { history1: true }; }
      else if (tnum === 1 && tunit === "day") { this.history3 = { history1: true }; }
      else if (tnum === 7 && tunit === "day") { this.history4 = { history1: true }; }

      const qs = require("qs");
      this.$axios
        .post("/api/dev/kd5/history", qs.stringify({ did: this.did, tnum: tnum, tunit: tunit }))
        .then((response) => {
          this.overlay = false;
          if (response.data.error_code === 0) {
            this.templist = [];
            this.temptimelist = [];
            for (var row of response.data.data.temp_buf) {
              this.templist.push(row.v);
              this.temptimelist.push(row.t);
            }
            this.drawtempLine();
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          }
        });
    },
    drawtempLine() {
      this.$nextTick(() => {
        var chartDom = document.getElementById("tempChart");
        if (!chartDom) return;
        let volChart = echarts.init(chartDom);
        var option = {
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,0.95)",
            borderColor: "#e2e8f0",
            borderWidth: 1,
            textStyle: { color: "#475569", fontSize: 12, fontFamily: "Inter, Noto Sans SC, sans-serif" },
            formatter: function (params) {
              return '<div style="font-weight:600;color:#1e293b;font-size:13px;margin-bottom:4px">' + params[0].axisValue + '</div>' +
                '<div style="display:flex;align-items:center;gap:6px;padding:2px 0">' +
                '<span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#2dd4bf"></span>' +
                '<span style="color:#64748b">' + params[0].seriesName + '：</span>' +
                '<span style="color:#1e293b;font-weight:600">' + params[0].value + '℃</span></div>';
            }
          },
          grid: { left: "8%", right: "8%", top: "8%", bottom: "18%" },
          xAxis: {
            type: "category", data: this.temptimelist,
            axisLine: { lineStyle: { color: "#e2e8f0" } },
            axisTick: { show: false },
            axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
            splitLine: { show: false },
          },
          yAxis: {
            type: "value",
            name: "温度/℃",
            nameTextStyle: { color: "#94a3b8" },
            axisLine: { show: false },
            axisTick: { show: false },
            axisLabel: { color: "#94a3b8", fontSize: 10, fontWeight: 400 },
            splitLine: { lineStyle: { color: "#f1f5f9", type: "dashed" } },
          },
          dataZoom: [{
            type: "slider", start: 0, end: 100,
            height: 24, bottom: 24,
            borderColor: "#e2e8f0", backgroundColor: "#f8fafc",
            fillerColor: "rgba(45,212,191,0.1)",
            handleStyle: { color: "#2dd4bf" },
            textStyle: { color: "#94a3b8", fontSize: 10 },
          }],
          series: {
            name: "温度",
            data: this.templist,
            type: "line",
            symbol: "none",
            smooth: true,
            lineStyle: { color: "#2dd4bf", width: 2 },
            areaStyle: { color: "rgba(45,212,191,0.06)" },
            itemStyle: { color: "#2dd4bf" },
          },
        };
        volChart.setOption(option);
      });
    },
	    gotohome() { this.$router.go(-1); },
	    handleClose(action, done) {
      if (action === "confirm") {
        done(false);  // 阻止自动关闭，等 API 返回后再关
        this.devsetalarm(done);
      } else if (action === "cancel") {
        if (this.devdata && this.devdata.config) {
          this.configdata.tul = this.devdata.config.tul;
          this.configdata.tdl = this.devdata.config.tdl;
          this.configdata.tjz = this.devdata.config.tjz / 10;
        }
        done();
      }
    },
    onSelect(item) {
      this.devconfigshow = false;
      if (item.name === "重命名") { this.devnamecard = true; }
      else if (item.name === "更改分组") { this.devgroupcard = true; }
      else if (item.name === "解绑") { this.devunbindcard = true; }
      else if (item.name === "设置报警") { this.dialogFormVisible = true; }
    },
    configstatus(statu) {
      this.devgroupcard = false;
      this.devnamecard = false;
      this.devunbindcard = false;
      this.dialogFormVisible = false;
      this.GetDevData(this.did);
      if (statu === true) { this.$toast.success("设置成功"); }
    },
    GetDevData(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
	          if (response.data.error_code === 0) {
	            this.devdata = response.data;
	            this.gethistory(1, "hour");
            this.automatic = response.data.config.automatic ? "手动模式" : "自动模式";
            this.valuelist = [];
            this.valuelist.push({ k: "温度", v: this.devdata.value.temperature + "℃" });
            this.valuelist.push({ k: "更新时间", v: this.devdata.time });
            this.configdata.tul = this.devdata.config.tul;
            this.configdata.tdl = this.devdata.config.tdl;
            this.configdata.tjz = this.devdata.config.tjz / 10;
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$router.push({ path: "/devlist" });
          }
        });
    },
    gotoconfig() { this.dialogFormVisible = true; },
    devsetalarm(done) {
      var databuf = JSON.stringify({
        tul: this.configdata.tul,
        tdl: this.configdata.tdl,
        tjz: Math.round(this.configdata.tjz * 10),
      });
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({ did: this.did, d_type: "KD-5", config: databuf }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.$notify({ type: "success", message: "设置报警成功！" });
            if (done) done();
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$notify({ type: "danger", message: "设置报警失败！" });
            if (done) done();
          }
        })
        .catch(() => {
          this.$notify({ type: "danger", message: "网络错误" });
          if (done) done();
        });
    },
    onReflash() {
      var databuf = JSON.stringify({});
      const qs = require("qs");
      this.$axios
        .post("/api/dev/easy_mqtt_config", qs.stringify({ did: this.did, d_type: "KD-5", config: databuf }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.isLoading = false;
            this.GetDevData(this.did);
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$notify({ type: "danger", message: "设置失败！" });
          }
        });
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Noto+Sans+SC:wght@400;500;600;700&display=swap");

.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}

.nav-devname {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
}

.nav-did {
  font-size: 11px;
  color: #94a3b8;
}

.crystal-actionsheet .van-action-sheet__header {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
}

.van-dialog.crystal-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.crystal-dialog .van-dialog__header {
  font-size: 17px;
  font-weight: 600;
  color: #1e293b;
  padding-top: 24px;
}

.crystal-dialog .van-dialog__confirm,
.crystal-dialog .van-dialog__confirm:active {
  color: #2dd4bf !important;
}

.crystal-dialog .van-dialog__cancel {
  color: #94a3b8;
}

.crystal-dialog .van-hairline--top {
  border-color: #f1f5f9;
}
</style>

<style scoped>
.devpage5-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: linear-gradient(145deg, #f0f9ff 0%, #fdf2f8 35%, #f0fdf4 100%);
  font-family: "Inter", "Noto Sans SC", sans-serif;
}

.devpage5-index {
  background: transparent !important;
  padding-bottom: 20px;
  min-height: 100vh;
  min-height: 100dvh;
}

	.temp-hero {
	  margin: 12px 12px 0;
	  border-radius: 18px;
	  padding: 36px 24px;
	  text-align: center;
	  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	  transition: background 0.4s ease;
	}
	
	.temp-hero--normal {
	  background: linear-gradient(135deg, #2dd4bf, #14b8a6);
	}
	
	.temp-hero--alert {
	  background: linear-gradient(135deg, #fb7185, #f43f5e);
	}

.temp-hero-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.temp-value {
  font-size: 64px;
  font-weight: 700;
  color: #fff;
  line-height: 1;
  font-family: "Inter", sans-serif;
}

.temp-unit {
  font-size: 28px;
  font-weight: 400;
  opacity: 0.8;
}

.temp-time {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-top: 8px;
}

.content-area {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-card {
  background: #ffffff;
  border-radius: 18px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
  overflow: hidden;
}

.info-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 16px;
  min-height: 24px;
}

.info-item--link { cursor: pointer; transition: background 0.15s; }
.info-item--link:active { background: #f8fafc; }

.info-item-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-icon {
  font-size: 17px;
  flex-shrink: 0;
}

.info-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.history-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.history-tabs {
  display: flex;
  gap: 8px;
  justify-content: center;
  padding: 0 4px;
}

.history-tab {
  flex: 1;
  height: 32px;
  padding: 0 4px;
  border: none;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  font-family: inherit;
  transition: all 0.2s;
  white-space: nowrap;
  text-align: center;
}

.history-tab--active {
  background: #2dd4bf;
  color: #fff;
}

.history-tab:not(.history-tab--active) {
  background: #f1f5f9;
  color: #94a3b8;
}

.history-tab:not(.history-tab--active):active {
  background: #e2e8f0;
}

.chart-card {
  background: #ffffff;
  border-radius: 18px;
  padding: 16px 12px 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04), 0 8px 24px rgba(0, 0, 0, 0.04);
}

.history-chart {
  height: 280px;
  width: 100%;
}

.dialog-body {
  padding: 8px 20px 16px;
}

.dialog-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
}

.dialog-label {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
}

.dialog-divider {
  height: 1px;
  background: #f1f5f9;
}
</style>
